export default __webpack_public_path__ + "static/media/avatar-7.5ba5195e.jpg";